// TODO: This should be replaced with ky
const HttpMethodGet = 'GET';
const HttpMethodHead = 'HEAD';
const HttpMethodPost = 'POST';
const HttpMethodPut = 'PUT';
const HttpMethodPatch = 'PATCH';
const HttpMethodDelete = 'DELETE';
const HttpMethodConnect = 'CONNECT';
const HttpMethodOptions = 'OPTIONS';
const HttpMethodTrace = 'TRACE';

export type BodyType = Blob | BufferSource | FormData | URLSearchParams | ReadableStream<Uint8Array> | string;

export type HttpMethod =
  | typeof HttpMethodGet
  | typeof HttpMethodHead
  | typeof HttpMethodPost
  | typeof HttpMethodPut
  | typeof HttpMethodPatch
  | typeof HttpMethodDelete
  | typeof HttpMethodConnect
  | typeof HttpMethodOptions
  | typeof HttpMethodTrace;

export interface HttpHeader {
  [x: string]: string;
}

interface HttpBaseOptions<T extends BodyType> {
  headers?: HttpHeader;
  body?: T;
  url: string;
}
export interface HttpOptions<T extends BodyType> extends HttpBaseOptions<T> {
  method: HttpMethod;
}

/**
 * @deprecated
 */
const Http = async function <T extends BodyType = string>({ url, method, body, headers }: HttpOptions<T>) {
  // Simple auth for testing .NET API
  const authHeaders =
    process.env.USER_EMAIL && process.env.USER_PASSWORD
      ? {
          Authorization: 'Basic ' + btoa(process.env.USER_EMAIL + ':' + process.env.USER_PASSWORD),
        }
      : {};

  return await fetch(url, {
    method,
    body,
    headers: Object.assign(
      {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...authHeaders,
      },
      headers
    ),
    credentials: 'same-origin',
  });
};

Http.get = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'GET',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.head = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'HEAD',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.post = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'POST',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.put = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'PUT',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.patch = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'PATCH',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.delete = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'DELETE',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.connect = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'CONNECT',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.options = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'OPTIONS',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

Http.trace = async function <T extends BodyType = string>(options: HttpBaseOptions<T>) {
  return await Http<T>({
    method: 'TRACE',
    headers: options.headers,
    url: options.url,
    body: options.body,
  });
};

export default Http;
